import { alpha } from '@mui/material/styles';

export const CONFIDENCE_HIGH_THRESHOLD = 0.9;
export const CONFIDENCE_MEDIUM_THRESHOLD = 0.6;

const PERCENT = 100;
const ICON_BG_ALPHA = 0.12;
const CHIP_BG_ALPHA = 0.15;
const PICKER_HOVER_ALPHA = 0.08;

export const formatConfidencePercent = fraction => `${Math.round(fraction * PERCENT)}%`;

// Popup shares this component with the doc-data edit surface: the "Select input to fill" picker
// renders only when an onFill handler is wired. The card grows to fit that list when present.
export const cardStyles = ({ palette }) => ({
  width: '300px',
  position: 'absolute',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: '12px',
  backgroundColor: palette.background.paper,
  color: palette.text.primary,
  border: `1px solid ${palette.divider}`,
  boxShadow: palette.shadow.l,
});

export const headerStyles = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 8px 10px 14px',
  borderBottom: `1px solid ${palette.divider}`,
});

export const fieldIconStyles = ({ palette }) => ({
  flex: '0 0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '6px',
  color: palette.primary.main,
  backgroundColor: alpha(palette.primary.main, ICON_BG_ALPHA),
});

export const fieldNameStyles = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const closeButtonStyles = {
  flex: '0 0 auto',
  width: '28px',
  height: '28px',
  padding: 0,
};

export const bodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '12px 14px 14px',
};

export const sectionLabelStyles = ({ palette }) => ({
  display: 'block',
  marginBottom: '4px',
  textTransform: 'uppercase',
  color: palette.text.secondary,
});

export const confidenceRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const confidenceTrackStyles = ({ palette }) => ({
  flex: 1,
  height: '6px',
  borderRadius: '999px',
  overflow: 'hidden',
  backgroundColor: palette.divider,
});

export const confidenceFillStyles = (fraction, color) => ({
  height: '100%',
  width: formatConfidencePercent(fraction),
  borderRadius: '999px',
  backgroundColor: color,
});

export const confidenceChipStyles = color => ({
  flex: '0 0 auto',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: '999px',
  color,
  backgroundColor: alpha(color, CHIP_BG_ALPHA),
});

export const pickerListStyles = ({ palette }) => ({
  maxHeight: '150px',
  '& .MuiListItem-root:hover': {
    backgroundColor: alpha(palette.primary.main, PICKER_HOVER_ALPHA),
  },
});
